<template>
  <div id="app">
    <router-view></router-view>
    <div id="J_GotoTop" class="elevator">
      <a class="elevator-msg" href="javascript:void(0)" onclick="doyoo.util.openChat('g=10080393'); return false;">
        <i class="iconfont icon-kefu"></i>
        <span class="">在线<br>客服</span>
      </a>
      <!--<a href="javascript:void(0)" target="_blank" class="elevator-app">-->
      <!--  <i class="iconfont icon-gongzhonghao"></i>-->
      <!--  <span class="">官方<br>微信</span>-->
      <!--  <div class="elevator-app-box"></div>-->
      <!--</a>-->
      <!--<a href="javascript:void(0)" class="elevator-weixin" id="js-elevator-weixin">-->
      <!--  <i class="iconfont icon-app"></i>-->
      <!--  <span class="">APP<br>下载</span>-->
      <!--  <div class="elevator-weixin-box"></div>-->
      <!--</a>-->
      <a id="backTop" class="elevator-top no-goto" href="javascript:void(0)" style="display: none;">
        <i class="iconfont icon-fanhuidingbu1"></i>
        <span class="">返回<br>顶部</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',
  mounted() {
    var btn = document.getElementById('backTop')
    // 获取视界高度；
    var winH = document.documentElement.clientHeight
    // 定义计时器；
    var timer = null
    // 定义是否抵达顶部布尔值判断；
    var isTop = true
    // 设置滚动事件；
    window.onscroll = function () {
      var toTop = document.body.scrollTop || document.documentElement.scrollTop
      // 判断是否到了第二屏，若是，显示按钮；
      if (toTop >= winH) {
        btn.style.display = 'block'
      } else {
        btn.style.display = 'none'
      }
      
      // 判断是否抵达顶部，若否，停止计时器；
      if (!isTop) {
        clearInterval(timer)
      }
      
      // 重置布尔值判断；
      isTop = false
    }
    // 设置按钮单击事件；
    btn.onclick = function () {
      // 设置计时器，50毫秒间隔；
      timer = setInterval(function () {
        var toTop = document.body.scrollTop || document.documentElement.scrollTop
        // 设置速度，用等式而不用具体数值是为了产生缓动效果；
        var speed = Math.ceil(toTop / 5)
        // 作差，产生缓动效果；
        document.documentElement.scrollTop = document.body.scrollTop = toTop - speed
        // 重置布尔值判断；
        isTop = true
        // 判断是否抵达顶部，若是，停止计时器；
        if (toTop == 0) {
          clearInterval(timer)
        }
        
      }, 50)
    }
  }
}
</script>

<style>
/*#app {*/
/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*-webkit-font-smoothing: antialiased;*/
/*-moz-osx-font-smoothing: grayscale;*/
/*text-align: center;*/
/*color: #2c3e50;*/
/*margin-top: 60px;*/
/*}*/


.elevator {
  position: fixed;
  z-index: 999;
  right: 0;
  bottom: 65px;
  margin-top: -140px;
  padding: 0px 15px 8px 15px;
  background-color: #38BCD5;
  box-shadow: 0 0px 12px 0 rgba(7, 17, 27, .8)
}

.elevator a {
  display: block;
  box-sizing: border-box;
  width: 40px;
  padding: 16px 0;
  text-align: center;
  border-bottom: 1px solid #FFFFFF
}

.elevator a:hover {
  color: #FFFFFF
}

.elevator a i {
  font-size: 40px;
  line-height: 40px;
  color: #FFFFFF;
}

.elevator a i:hover {
  color: #14191E
}

.elevator a span {
  font-size: 16px;
  line-height: 19px;
  display: none;
  color: #FFFFFF;
  
}

.elevator .no-goto {
  border-bottom: none
}

.elevator .elevator-app:hover i, .elevator .elevator-faq:hover i, .elevator .elevator-msg:hover i, .elevator .elevator-top:hover i, .elevator .elevator-weixin:hover i {
  display: none
}

.elevator .elevator-app:hover span, .elevator .elevator-faq:hover span, .elevator .elevator-msg:hover span, .elevator .elevator-top:hover span, .elevator .elevator-weixin:hover span {
  display: inline-block
}

.elevator .elevator-app-box {
  position: absolute;
  right: 56px;
  bottom: -2px;
  width: 172px;
  max-width: 0;
  height: 212px;
  -moz-transition: opacity .25s, transform .3s;
  -webkit-transition: opacity .25s, transform .3s;
  transition: opacity .25s, transform .3s;
  -ms-transform: scale(.01);
  -webkit-transform: scale(.01);
  transform: scale(.01);
  -ms-transform-origin: 100% 95%;
  -webkit-transform-origin: 100% 95%;
  transform-origin: 100% 95%;
  opacity: 0;
  background: url(assets/images/wwx.gif) no-repeat;
  filter: alpha(opacity=0);
}

.elevator .elevator-app:hover .elevator-app-box {
  display: block;
  visibility: visible;
  max-width: none;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  filter: alpha(opacity=100);
}

.elevator .elevator-weixin-box {
  position: absolute;
  right: 56px;
  bottom: -4px;
  width: 172px;
  max-width: 0;
  height: 212px;
  -moz-transition: opacity .25s, transform .3s;
  -webkit-transition: opacity .25s, transform .3s;
  transition: opacity .25s, transform .3s;
  -ms-transform: scale(.01);
  -webkit-transform: scale(.01);
  transform: scale(.01);
  -ms-transform-origin: 100% 95%;
  -webkit-transform-origin: 100% 95%;
  transform-origin: 100% 95%;
  opacity: 0;
  background: url(assets/images/xzapp.gif) no-repeat;
  filter: alpha(opacity=0);
}

.elevator .elevator-weixin:hover .elevator-weixin-box {
  display: block;
  visibility: visible;
  max-width: none;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  filter: alpha(opacity=100);
}
</style>



// WEBPACK FOOTER //
// src/App.vue